import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";
import config from '../../config';
import { PrimeReactProvider } from 'primereact/api';
import { Dropdown } from 'primereact/dropdown';
import { Checkbox } from "primereact/checkbox";
import "primereact/resources/themes/lara-light-cyan/theme.css";

function UpdateTeamDetail() {
    const { id } = useParams();
    const navigate = useNavigate();
    const [team, setTeam] = useState({ title: '', description: '' });
    const [featuredImage, setFeaturedImage] = useState(null);

    const [error, setError] = useState('');
    const [successMessage, setSuccessMessage] = useState('');
    const fileInputRef = useRef(null);
    const featuredImageRef = useRef(null);

    useEffect(() => {
        const fetchPostDetails = async () => {
            try {
                const response = await axios.get(`${config.BASE_URL}/api/admin/get-team/${id}`, { withCredentials: true });
                setTeam(response.data);

            } catch (err) {
                setError('Failed to fetch team details');
            }
        };

        fetchPostDetails();
    }, [id]);

    const handleRemoveImage = async (imageName, repeaterName=null, index=0) => {
        try {
            const response = await axios.post(`${config.BASE_URL}/api/admin/remove-image-team`, {
                teamId: team._id,
                imageName
            }, { withCredentials: true });

            if (response.status === 200) {
                setTeam(prevProperty => {
                    return {
                        ...prevProperty,
                        featuredImage: prevProperty.featuredImage === imageName ? null : prevProperty.featuredImage,
                    };
                });

            } else {
                console.error('Failed to remove image');
            }
        } catch (err) {
            console.error('Error removing image:', err);
        }
    };

    const handleFeaturedImageChange = (e) => {
        setFeaturedImage(e.target.files[0]);
    };

    const handleFormSubmit = async (e) => {
        e.preventDefault();
        const formData = new FormData();
        formData.append('title', team.title);
        formData.append('position', team.position);
        formData.append('whatsapp', team.whatsapp);
        formData.append('email', team.email);
        
        if (featuredImage) {
            formData.append('featuredImage', featuredImage);
        }

        try {
            const response = await axios.put(`${config.BASE_URL}/api/admin/update-team/${id}`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
                withCredentials: true,
            });

            setTeam(response.data.team);

            if (featuredImageRef.current) {
                featuredImageRef.current.value = '';
            }

            setFeaturedImage(null);
            setSuccessMessage('Team updated successfully!');
        } catch (err) {
            setError('Failed to update Team');
        }
    };

    return (
        <PrimeReactProvider>
            <div className="dashboard update_detail_wrap">
                <div className="container">
                    <h1 className="dash_title">Edit Team Member</h1>
                    <div className="back_btn_wrap">
                        <button className="back-btn" onClick={() => navigate(-1)}>Go Back</button>
                    </div>
                    {team ? (
                        <form onSubmit={handleFormSubmit} encType="multipart/form-data">
                            <div className="update_details_wrap">
                                <div className="form-group">
                                    <label>Name</label>
                                    <input
                                        type="text"
                                        value={team.title}
                                        onChange={(e) => setTeam({ ...team, title: e.target.value })}
                                    />
                                </div>

                                <div className="form-group">
                                    <label>Position</label>
                                    <input
                                        type="text"
                                        value={team.position}
                                        onChange={(e) => setTeam({ ...team, position: e.target.value })}
                                    />
                                </div>

                                <div className="form-group">
                                    <div className="detail_banner_wrap">
                                        <div className="detail_img_grid">
                                            <div className="upload_item">
                                                <label>Featured Image</label>
                                                <input type="file" onChange={handleFeaturedImageChange} ref={featuredImageRef} />
                                            </div>

                                            <div className="detail_img_grid">
                                                {team.featuredImage ? (
                                                    <div className="detail_img_item">
                                                        <div className="banner_img_wrap">
                                                            <img src={`${config.BASE_URL}${team.featuredImage}`} alt="Featured" />
                                                        </div>
                                                        <button className="remove_btn" type="button" onClick={() => handleRemoveImage(team.featuredImage)}>Remove</button>
                                                    </div>
                                                ) : (
                                                    <p>No image available.</p>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="update_btn_wrap">
                                    <button className="update_btn" type="submit">Update Team Member</button>
                                </div>

                                {successMessage && <p className="success-message">{successMessage}</p>}
                                {error && <p className="error-message">{error}</p>}

                            </div>
                        </form>
                    ) : (
                        <h5>Team not found!</h5>
                    )}
                </div>
            </div>
        </PrimeReactProvider>
    );
}

export default UpdateTeamDetail;
